<template>

  <div class="main">
    <header>
      <div class="text" style="float: left;">
        <h2 > 修改密码</h2>
      </div>
      <div style="  clear:both;"></div>
      </header>
  <div class="grid-content bg-purple table-box">
    <el-form ref="form" :model="form" label-width="150px">

<!--      <el-form-item class="el-form-name" label="头像：" >-->
<!--        <el-upload-->
<!--          class="avatar-uploader"-->
<!--          :action="afileUrl"-->
<!--          :show-file-list="false"-->
<!--          :on-success="handleAvatarSuccess"-->
<!--          :before-upload="beforeAvatarUpload">-->
<!--          <img v-if="circleUrl" :src="circleUrl" class="avatar">-->
<!--          <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--        </el-upload>-->

<!--      </el-form-item>-->

      <el-form-item class="el-form-name" label="新密码：">
        <el-input v-model="form.pwd" type="password" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item class="el-form-name" label="确认密码：">
        <el-input v-model="form.spwd" type="password" placeholder="确认密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确认提交</el-button>

      </el-form-item>
    </el-form>
  </div>
  </div>
</template>

<script>
export default {
  name: "Install",
  props:['circleUrl'],
  data(){
    return{
      afileUrl:'/webapi/upload/oneDoc',

      form: {
        pwd: '',
        spwd: '',
      },

    }
  },
  methods:{
    handleAvatarSuccess(res, file) {
      var that = this;
      if(res.code==200){
        that.scoreItemUrl = res.data.url;
        that.fileName = res.data.fileName;
        that.userupdate(that.scoreItemUrl)

      }else{
        that.$message.error('上传失败');
      }
    },
    userupdate(userimg){
      var that = this;
      var ueers ={
        avatar:userimg,
        accountStatus:1,
      }
      that.$axios.defaults.withCredentials=true;
      that.$axios
        .post('/webapi/user/update',ueers)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '保存成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);


          }else{
            that.$message.error(
              '保存失败'
            );
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、JPEG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
//修改密码


    onSubmit() {
      var that = this;
      if (that.form.pwd == '') {
        that.$message.error('请输入密码');
        return false;
      }
      if (that.form.spwd == '') {
        that.$message.error('请输入确认密码');
        return false;
      }

      if (that.form.pwd != that.form.spwd) {
        that.$message.error('密码输入不一致');
        return false;
      }
      var formdata = {
        passWord:that.form.pwd,
        confirmPassWord:that.form.spwd
      }

      this.$axios
        .post('/webapi/user/updatePassWord', formdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("密码修改失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '密码修改成功',
              type: 'success'
            });

            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
  }
}
</script>
<style>
.el-form-name>.el-form-item__label{
  height: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
</style>
<style scoped>

.el-form{
  width: 577px;
}

.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}

.el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
.
.el-main{
  width: 100%;
  background-color: #fff;
  color: #333;
  text-align: left !important;
  padding: 0;
}
.grid-main {
  border-radius: 0px;
  min-height: 36px;
  position: relative;
  margin-bottom: 20px;
  padding: 60px;
}
/deep/ .el-button--primary{
  width: auto!important;
  margin-bottom: 30px;
  margin-top: 0px!important;
  float: right;

}
.table-box {
  margin-top: 30px;
  padding:60px;
  background: #FFFFFF;
}
.el-menu-item{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin: 25px auto;
  height: 78px;
  padding-right: 8px!important;
  padding-left: 8px!important;
  padding-bottom: 20px!important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/view/Install.vue